"use client";
import { User } from "@/api/users";
import { GridColDef } from "@mui/x-data-grid";

export const columns: GridColDef<User>[] = [
    {
        field: "id",
        headerName: "ID",
    },
    {
        field: "email",
        flex: 2,
        headerName: "Email",
    },
    {
        field: "roles",
        flex: 2,
        headerName: "Role(s)",
        valueFormatter: (value: [{ name: string; }]) => value.map(r => r.name).join(', ')
    }, {
        field: "requires_signals_notifications",
        flex: 1,
        headerName: "Signals Notifications",
        valueFormatter: (value: boolean) => value ? 'Yes' : 'No',
    }, {
        field: "requires_account_summary_notifications",
        flex: 1.5,
        headerName: "Account Summary Notifications",
        valueFormatter: (value: boolean) => value ? 'Yes' : 'No',
    }, {
        field: "credit_limit",
        flex: 1,
        headerName: "Credit Limit",
        valueFormatter: (value: number) => value.toFixed(2),
    }
];
